import { createSlice } from "@reduxjs/toolkit";

export const templateTypeSlice = createSlice({
  name: "templateType",
  initialState: {
    getTemplateTypeResult: false,
    getTemplateTypeLoading: false,
    getTemplateTypeError: false,
    addTemplateTypeResult: false,
    addTemplateTypeLoading: false,
    deleteTemplateTypeResult: false,
  },
  reducers: {
    templateTypeReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_TEMPLATETYPE":
          return {
            ...state,
            getTemplateTypeResult: payload.data,
            getTemplateTypeLoading: payload.loading,
            getTemplateTypeError: payload.error,
          };
        case "ADD_TEMPLATETYPE":
          return {
            ...state,
            addTemplateTypeResult: payload.data,
            addTemplateTypeLoading: payload.loading,
          };
        case "DELETE_TEMPLATETYPE":
          return {
            ...state,
            deleteTemplateTypeResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { templateTypeReducers } = templateTypeSlice.actions;

export default templateTypeSlice.reducer;
